import "antd/dist/antd.css";
import React, { useState, useEffect, useReducer } from "react";
import { Row, Col } from "antd";
import { initialState, reducer } from "./reducer";
import { useSelector } from "react-redux";
import Search from "./components/Search";
import MyPatronagersList from "./components/List";
import PatronagerService from "../../../../services/Election/Patronage/PatronagerService";
import moment from "moment";
import Edit from "./components/Edit";
import SimpleHeader from "../../../../helpers/cards-helper/SimpleHeader";
import { getErrorMessage } from "../../../../helpers/ErrorHelper";




const MyPatronagers = () => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const token = useSelector((state) => state.Member.token);
    const [searchLoading, setSearchLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);


    useEffect(() => {
        updateLoading(true);
        setSearchLoading(true);
        PatronagerService.getMyPatronagersList(token, state.filters)
            .then((response) => {
                let index = 0;
                const itemsList = response.data.data.map((elm) => {
                    index += 1;
                    return {
                        index: index,
                        name: elm?.voter?.name,
                        surname: elm?.voter?.surname,
                        qv_code: elm?.voter?.qv?.code,
                        list_number: elm?.voter?.list_number,
                        building_no: elm?.voter?.building_number,
                        birthdate: moment(elm?.voter?.dob).format("DD-MM-YYYY"),
                        age: elm?.voter?.age,
                        phone: elm?.voter?.phone,
                        email: elm?.voter?.email,
                        is_emigrant: elm?.voter?.is_emigrant,
                        first_time: elm?.voter?.first_time,
                        political_preference: elm?.political_preference?.name,
                        is_partymember: elm?.voter?.is_partymember,
                        ...elm,
                    };
                });
                const itemsCount = response.data.count;
                const action = {
                    type: "set_items",
                    payload: {
                        items: itemsList,
                        total: itemsCount,
                    },
                };
                dispatch(action);
                updateLoading(false);
                setSearchLoading(false);
                setErrorMessage(null);
            })
            .catch((err) => {
                const action = {
                    type: "set_items",
                    payload: {
                        items: [],
                        total: 0,
                    },
                };
                dispatch(action);
                const errorMessage = getErrorMessage(err);
                setErrorMessage(errorMessage);
                updateLoading(false);
                setSearchLoading(false);
            });
    }, [token, state.filters, state.requestData]);


    useEffect(() => {
        PatronagerService.getPoliticalPreferencesList(token)
            .then((response) => {
                const action = {
                    type: "set_political_preferences",
                    payload: response.data,
                };
                dispatch(action);
            })
            .catch((err) => { });
    }, [token]);


    useEffect(() => {
        PatronagerService.getEmigrantCountriesList(token)
            .then((response) => {
                const action = {
                    type: "set_countries",
                    payload: response.data,
                };
                dispatch(action);
            })
            .catch((err) => { });
    }, [token]);


    const updateLoading = (isLoading) => {
        const action = {
            type: "set_loading",
            payload: isLoading,
        };
        dispatch(action);
    };


    const refreshList = () => {
        const action = {
            type: "refresh_list",
        };
        dispatch(action);
    };


    const updateIndexVisibility = (indexVisibility) => {
        const action = {
            type: "set_index_visibility",
            payload: indexVisibility,
        };
        dispatch(action);
    };


    const onSuccess = () => {
        refreshList();
        updateIndexVisibility(0);
    };


    return (
        <Row gutter={24} className="page-content">
            <Col span={24}>

                {state.indexVisibility === 0 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <SimpleHeader
                                title="Të patronazhuarit e mi"
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 0 && (
                    <Row gutter={24} className="mt-2">
                        <Col span={24}>
                            <Search
                                dispatch={dispatch}
                                initialFilters={state.filters.searchFilters}
                                searchLoading={searchLoading}
                            />
                        </Col>
                    </Row>

                )}

                {state.indexVisibility === 0 && (
                    <Row gutter={24} className="mt-2">
                        <Col span={24}>
                            <MyPatronagersList
                                dispatch={dispatch}
                                items={state.items}
                                totalCount={state.totalCount}
                                initialPagination={state.filters.pagination}
                                errorMessage={errorMessage}
                                filters={state.filters}
                                isLoading={state.isLoading}
                                onRefreshList={() => refreshList()}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 1 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <Edit
                                dispatch={dispatch}
                                item={state.itemSelected}
                                politicalPreferences={state.politicalPreferences}
                                countries={state.countries}
                                onSuccess={onSuccess}
                                onBack={() => updateIndexVisibility(0)}
                            />
                        </Col>
                    </Row>
                )}

            </Col>
        </Row>
    );
};


export default MyPatronagers;